export const mapStateToForm = (stateItems, userItems, key = "id") =>
  stateItems.map((stateItem) => {
    const check = userItems.some(
      (userItem) => userItem[key] === stateItem[key]
    );
    return { ...stateItem, checked: check };
  });
